import React from "react";
import { Box } from "@mui/material";
import FormLayoutHeader from "../../../layoutComponents/FormLayout/FormLayoutHeader";
import { useWebViewContext } from "../../../components/WebViewProvider/webViewContext";
import Header from "../../../layoutComponents/Header";

const SetPasswordSuccess = () => {
    const { isWebView } = useWebViewContext();

    return (
        <>
            {isWebView && <Header flex />}

            <FormLayoutHeader align="center" title="Nové heslo bylo úspěšně nastaveno." />

            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: "1rem" }}>
                <svg width="61" height="60" viewBox="0 0 61 60" fill="none">
                    <g>
                        <path
                            d="M23.5 29.5647L28.4888 36.0162L39.3991 24"
                            stroke="#FF5F1F"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M30.5 59C46.5163 59 59.5 46.0163 59.5 30C59.5 13.9837 46.5163 1 30.5 1C14.4837 1 1.5 13.9837 1.5 30C1.5 46.0163 14.4837 59 30.5 59Z"
                            stroke="#FF5F1F"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </svg>
            </Box>
        </>
    );
};

export default SetPasswordSuccess;
